import { render, staticRenderFns } from "./OpenBookingPay.vue?vue&type=template&id=30865110&scoped=true"
import script from "./OpenBookingPay.vue?vue&type=script&lang=js"
export * from "./OpenBookingPay.vue?vue&type=script&lang=js"
import style0 from "./OpenBookingPay.vue?vue&type=style&index=0&id=30865110&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30865110",
  null
  
)

export default component.exports